import * as React from 'react';

import { LocationsPageLocale } from './locationsPage.locale';
import Header from '../Header/Header';
import List from '../List/List';
import LocationsList from './LocationsList/LocationsList';
import headerBg from './headerBg.svg';

interface LocationsPageProps {
  locale: LocationsPageLocale;
}

const LocationsPage: React.SFC<LocationsPageProps> = ({ locale }) => (
  <>
    <Header
      title={locale.header.title}
      subtitle={locale.header.subtitle}
      backgroundImage={headerBg}
      backgroundSize="auto 135%"
    />
    <main>
      <div className="container py-7 py-md-8">
        <div className="row">
          <div className="col-12 col-lg-6">
            <h2 className="mb-5 mr-lg-7 mb-lg-0">{locale.title}</h2>
          </div>
          <div className="col-12 col-lg-6 mt-1">
            <List items={locale.features} />
          </div>
        </div>
        <LocationsList locale={locale.locations} />
      </div>
    </main>
  </>
);

export default LocationsPage;



// WEBPACK FOOTER //
// /www/client/src/components/LocationsPage/LocationsPage.tsx